import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-calling-policy",
  templateUrl: "./calling-policy.component.html",
  styleUrls: ["./calling-policy.component.scss"],
})
export class CallingPolicyComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
